<template>
    <div class="popup-admin">
      <h1>🔧 팝업창 관리</h1>
  
      <div class="button-bar">
        <button @click="goBack" class="back-button">이전으로</button>
        <button @click="goToCreate">➕ 새 팝업 등록</button>
      </div>
  
      <div v-if="popups.length === 0" class="no-data">
        등록된 팝업이 없습니다.
      </div>
  
      <table v-else class="popup-table">
        <thead>
          <tr>
            <th>제목</th>
            <th>표시 시작일</th>
            <th>표시 종료일</th>
            <th>상태</th>
            <th>관리</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="popup in popups" :key="popup.id">
            <td>{{ popup.title }}</td>
            <td>{{ formatDate(popup.startTs) }}</td>
            <td>{{ formatDate(popup.endTs) }}</td>
            <td>
              <span :class="isActive(popup) ? 'status-on' : 'status-off'">
                {{ isActive(popup) ? '활성' : '비활성' }}
              </span>
            </td>
            <td>
              <button @click="editPopup(popup)" style="margin-right: 8px;">✏️ 수정</button>
              <button @click="deletePopup(popup)">🗑 삭제</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue';
  import { useRouter } from 'vue-router';
  import axios from '@/utils/axios';
  
  const router = useRouter();
  const popups = ref([]);
  
  const fetchPopups = async () => {
    try {
      const res = await axios.get('/api/bx201/popup');
      popups.value = res.data;
    } catch (err) {
      console.log(err)
    }
  };

  const goBack = () => {
    router.push('/admin')
  }
  
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return isNaN(date) ? '' : `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  };
  
  const goToCreate = () => {
    router.push('/admin/popup/create');
  };
  
  const editPopup = (popup) => {
    router.push({ name: 'PopupEdit', params: { id: popup.id } });
  };
  
  const deletePopup = async (popup) => {
    if (!confirm('정말 삭제하시겠습니까?')) return;
  
    try {
      await axios.delete(`/api/bx201/popup/${popup.id}`);
      fetchPopups(); // 목록 다시 불러오기
    } catch (err) {
      alert('삭제 실패');
    }
  };
  
  const isActive = (popup) => {
  const now = new Date();
  const start = new Date(popup.startTs);
  const end = new Date(popup.endTs);

  // 날짜만 비교 (YYYY-MM-DD)
  const nowYMD = now.toISOString().slice(0, 10);
  const startYMD = start.toISOString().slice(0, 10);
  const endYMD = end.toISOString().slice(0, 10);

  return nowYMD >= startYMD && nowYMD <= endYMD;
};


  onMounted(fetchPopups);
  </script>
  
  <style scoped>
  .popup-admin {
    max-width: 1000px;
    margin: 60px auto;
    padding: 30px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }
  
  h1 {
    margin-bottom: 20px;
    text-align: center;
    color: #333;
  }
  
  .button-bar {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  
  .button-bar button {
    padding: 8px 16px;
    font-size: 0.95rem;
    background-color: #28a745;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
  }
  
  .popup-table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .popup-table th,
  .popup-table td {
    border: 1px solid #ccc;
    padding: 12px;
    text-align: center;
  }
  
  .status-on {
    color: green;
    font-weight: bold;
  }
  
  .status-off {
    color: red;
    font-weight: bold;
  }
  
  .no-data {
    text-align: center;
    padding: 60px 0;
    font-size: 1.1rem;
    color: #666;
  }
  button {
    padding: 6px 12px;
    font-size: 0.9rem;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  </style>
  